import React from 'react';
import csv from 'csv';
import { GET_LIST } from 'admin-on-rest';
import seayourboatRestClient from '../restClient';
import { FlatButton } from 'material-ui';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';

const restClient = seayourboatRestClient('https://api.theboxapp.gr/api');
// const restClient = seayourboatRestClient('http://localhost:3111/api');

class DownloadButton extends React.Component {

  handleClick = (e) => {
    // console.log(this.props);
    const resource = this.props.resource;
    const downloadFile = (text, fileName) => {
      var blob = new Blob([text], {
         type: 'text/csv;charset=utf8;'
       });

       // create hidden link
       var element = document.createElement('a');
       document.body.appendChild(element);
       element.setAttribute('href', window.URL.createObjectURL(blob));
       element.setAttribute('download', fileName);
       element.style.display = '';

       element.click();

       document.body.removeChild(element);
       e.stopPropagation();
    }

    restClient(GET_LIST, resource, {
      pagination: {
        page: 1,
        perPage: 100000,
      },
      sort: {
        field: 'id',
        order:'DESC',
      },
      filter: {},
    }).then((data) => {
        console.log(data);
        csv.stringify(data.data, [],function(err, result) {
          if (err) {
            console.log(err);
          }

          console.log('csv finished, data:');
          console.log(result);
          downloadFile(result, `${resource}.csv`);
        });
      });
  }

  render() {
    return (
      <FlatButton primary label="Export" icon={<DownloadIcon />} onClick={this.handleClick} />
    );
  }
}

export default DownloadButton;



// WEBPACK FOOTER //
// ./src/custom/downloadButton.js